export default "__VITE_ASSET__32121b20__"